import { render } from "./ScanStatusPill.vue?vue&type=template&id=ef835b5c"
import script from "./ScanStatusPill.vue?vue&type=script&lang=js"
export * from "./ScanStatusPill.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__